import { render, staticRenderFns } from "./AppointmentDetail.vue?vue&type=template&id=4522b3a8&"
import script from "./AppointmentDetail.vue?vue&type=script&lang=js&"
export * from "./AppointmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports